<div id="termCondition" class="ya-typography" [ngClass]="isEMenu? 'emenu':''">
  <!-- <div class="page-header">

    <div class="header-title">
      
    </div>
    <div class="header-action-container">
      <div class="header-action-item">
      </div>
    </div>
  </div> -->
  <ya-subheader [hasContent]="true">
    <div class="menu-header-container">
      <mat-tab-group id="headerTabs" [(selectedIndex)]="currentTermIndex" animationDuration="20ms"
        (focusChange)="headerTabFocusChange($event)"
        class="ya-tab-group ya-tab-group--bodyless ya-tab-group--notStretch">
        <ng-container *ngFor="let term of impressumTermViewModel">
          <mat-tab a11y_Button [label]="term.label">

          </mat-tab>
        </ng-container>
      </mat-tab-group>
    </div>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop" (swipeleft)="swipeLeftHandler()"
    (swiperight)="swipeRightHandler()">
    <mat-tab-group [(selectedIndex)]="currentTermIndex" animationDuration="20ms" class="ya-headerless-tab-group">
      <ng-container *ngFor="let term of impressumTermViewModel">
        <mat-tab [label]="term.label">
          <div class="term-condition-container">
            <div class="impressum-info">
              <div class="term-condition-item-impressum" id="term" [innerHtml]="term.termHtmlContent">
              </div>
              <div class="item-list-divider"></div>
              <div class="operatorInformation">
                <h2 langkey="phOperator_Info_Title"></h2>
                <span langkey="phOperator_Info_Content"></span>
              </div>
            </div>
          </div>
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  </div>
</div>